// index.js
import {default as en} from './en.json'
import {default as de} from './de.json'
import {default as fr} from './fr.json'

export const defaultLocale = 'de'

export const languages = {
    en: en,
    de: de,
    fr: fr
}
